export enum EConfigurations {
  BRAND_PRIORITY = "BRAND_PRIORITY",
  BRAND_PRIORITY_LIST = "BRAND_PRIORITY_LIST",
  SAME_BRAND_ECOSYSTEM = "SAME_BRAND_ECOSYSTEM",
  MINIMIZE_COMPONENT_COUNT = "MINIMIZE_COMPONENT_COUNT",
  MATCH_VOLTAGE_ACROSS_COMPONENTS = "MATCH_VOLTAGE_ACROSS_COMPONENTS",
  MINIMIZE_MAINTENANCE_RISK = "MINIMIZE_MAINTENANCE_RISK",
  BRAND_PRIORITY_PREFERENCE = "BRAND_PRIORITY_PREFERENCE",
  OPTIMIZE_FOR_COST = "OPTIMIZE_FOR_COST",
  PREFER_HIGH_EFFICIENCY_PANELS = "PREFER_HIGH_EFFICIENCY_PANELS",
  RECOMMEND_EXPANDABLE_SYSTEMS = "RECOMMEND_EXPANDABLE_SYSTEMS",
}
